"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computePathAfterPatch = exports.getPathsOfLevels = exports.joinPathParts = exports.toPathParts = exports.pushPath = exports.popPath = void 0;
/**
 * Input: `"/foo/bar/baz"`
 * Output: `["/foo/bar", "baz"]`
 *
 * If `path` is empty or invalid, returns `null`
 *
 * If key contains slashed, they will be unescaped
 */
function popPath(path) {
    let revIdx = path.length;
    while (revIdx !== -1) {
        revIdx = path.lastIndexOf('/', revIdx - 1);
        if (path.charAt(revIdx - 1) !== '\\')
            break;
    }
    if (revIdx === -1)
        return null;
    let key = path.slice(revIdx + 1);
    if (key.includes('\\'))
        key = key.replace(/\\./g, x => x[1]);
    return [path.slice(0, revIdx), key];
}
exports.popPath = popPath;
/**
 * Input: `["/foo/bar", "baz"]`
 * Output: `"/foo/bar/baz"`
 *
 * If newKey is empty, returns `existing`
 *
 * If key contains slashed, they will be escaped
 */
function pushPath(existing, newKey) {
    if (!newKey && newKey !== '' && newKey !== 0)
        return existing;
    return `${existing}/${typeof newKey === 'string' ? newKey.replace(/[\\/]/g, '\\$&') : newKey}`;
}
exports.pushPath = pushPath;
/**
 * 将 path 字符串切割为多个单项的数组，例如 `'/foo/bar/baz'` 变成 `['foo', 'bar', 'baz']`
 */
function toPathParts(path) {
    if (!path)
        return [];
    if (Array.isArray(path))
        return path.map(String);
    const ans = [];
    while (true) {
        const sep = popPath(path);
        if (!sep)
            break;
        const [a, k] = sep;
        ans.unshift(k);
        // eslint-disable-next-line no-param-reassign
        path = a;
    }
    return ans;
}
exports.toPathParts = toPathParts;
/**
 * 将 多个单项的数组拼接为字符串，会处理转义字符的问题，例如 `['foo', 'bar', 'baz']` 拼接成 `'/foo/bar/baz'`
 */
function joinPathParts(parts) {
    let tmp = '';
    for (let i = 0; i < parts.length; i++)
        tmp = pushPath(tmp, parts[i]);
    return tmp;
}
exports.joinPathParts = joinPathParts;
/**
 * 将 path 字符串切割为多个维度的 path，例如 `'/foo/bar/baz'` 变成 `['/foo', '/foo/bar', '/foo/bar/baz']`
 */
function getPathsOfLevels(path) {
    if (!path)
        return [];
    if (Array.isArray(path)) {
        let tmp = '';
        return path.map((key) => {
            tmp = pushPath(tmp, String(key));
            return tmp;
        });
    }
    const ans = [];
    while (true) {
        const sep = popPath(path);
        if (!sep)
            break;
        const [a] = sep;
        ans.unshift(path);
        // eslint-disable-next-line no-param-reassign
        path = a;
    }
    return ans;
}
exports.getPathsOfLevels = getPathsOfLevels;
/**
 * 计算一个 Patch 发生了应用，会怎么影响其他的东西
 *
 * @param oldPath
 * @param patch
 * @returns false 表示原来的 path 不复存在
 */
function computePathAfterPatch(oldPath, patch) {
    var _a, _b;
    if (typeof oldPath !== 'string')
        return false;
    const modPath = patch.path;
    const modPathLen = modPath.length;
    switch (patch.op) {
        case 'resortArray': {
            // 如果是当前数组下面的一个元素，才可能收到影响
            if (!(oldPath.startsWith(modPath) && oldPath[modPathLen] === '/'))
                return oldPath;
            const oldIdx = parseInt(oldPath.slice(modPathLen + 1), 10);
            const newIdx = patch.indexMap.indexOf(oldIdx);
            if (newIdx === -1)
                return false;
            if (newIdx === oldIdx)
                return oldPath;
            return `${modPath}/${newIdx}${oldPath.substr(modPathLen + 1 + String(oldIdx).length)}`;
        }
        case 'spliceArray': {
            // 如果是当前数组下面的一个元素，才可能收到影响
            if (!(oldPath.startsWith(modPath) && oldPath[modPathLen] === '/'))
                return oldPath;
            const oldIdx = parseInt(oldPath.slice(modPathLen + 1), 10);
            const spliceStart = patch.start;
            if (oldIdx < spliceStart)
                return oldPath;
            const deleteCount = ((_a = patch.deleteCount) !== null && _a !== void 0 ? _a : Infinity);
            if (oldIdx - spliceStart < deleteCount)
                return false; // deleted
            const newIdx = oldIdx - deleteCount + (((_b = patch.items) === null || _b === void 0 ? void 0 : _b.length) || 0);
            return `${modPath}/${newIdx}${oldPath.substr(modPathLen + 1 + String(oldIdx).length)}`;
        }
        case 'delete':
        case 'create':
        case 'set': {
            // 如果和当前没有关系，就直接跳过
            if (!(oldPath.startsWith(modPath) && (oldPath.length === modPathLen || oldPath[modPathLen] === '/')))
                return oldPath;
            return false;
        }
    }
}
exports.computePathAfterPatch = computePathAfterPatch;
